import { api } from './Fetcher';

export const postPlayerRegistration = (data: FormData): Promise<any> => {
  return api.post('/signup/player/', data);
};

export const postCheckEmail = (data: any): Promise<any> => {
  return api.post('/signup/player/verify/email/', data);
};
